class DiamondDetails {
  constructor() {
    this.cartManager = new ShopifyCartManager();
    this.spinnerOverlayManager = new LBDOverlaySpinnerManager();
    
    this.conversionRate =
      Shopify.currency.active !== "AUD" ? Shopify.currency.rate : 1;

    // Initialize the media loader
    this.mediaLoader = new LbdDsrbMediaLoader();

    this.nameElement = document.getElementById("diamond-name");
    this.priceElement = document.getElementById("diamond-price");
    this.detailsElement = document.getElementById("diamond-details");
    this.tableElement = document.getElementById("diamond-table");
    this.fourCsInfographicElement = document.getElementById(
      "diamond-4Cs-infographic"
    );
    this.optionsAddToElement = document.getElementById("options-add-to");
    this.shippingInfoElement = document.getElementById("shipping-info");

    //accordions
    this.productInfoElement = document.getElementById("product-info");
    this.certificateInfoElement = document.getElementById("certificate-info");
    this.questionsInfoElement = document.getElementById("questions-info");
    
    this.imageElement = document.getElementById("diamond-image");
    this.mediaContainer2 = document.getElementById("secondary-media-container");
    this.imageElement2 = document.getElementById("diamond-image-2");
    this.videoContainer = document.getElementById("diamond-video-container");
    this.mediaContainer = document.getElementById("diamond-media-container");

    this.apiBaseUrl = 'https://api.lovebydeccla.com';

    this.diamond = null;
    this.modalElement = null;

    // this.loadingSpinner = document.getElementById("lbd-loading-spinner-overlay");
    
    this.content = document.getElementById("content");

    // Add PDF.js script to the document
    const script = document.createElement("script");
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.9.359/pdf.min.js";
    document.head.appendChild(script);

    script.onload = () => {
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.9.359/pdf.worker.min.js";
    };

    this.init();
  }

  async init() {
    try {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const diamondId = urlParams.get("id");

        this.spinnerOverlayManager.show()

        if (!diamondId) {
          this.showDiamondNotAvailable();
          throw new Error("No diamond ID provided");
        }

        this.diamond = await this.fetchDiamondDetails(diamondId);
        this.convertCurrency(this.diamond);
        this.displayDiamondDetails(this.diamond);

        // Wait for the next frame to ensure the content is rendered
        requestAnimationFrame(() => {
          this.spinnerOverlayManager.hide();
          this.content.style.display = "block";
          this.setupMediaWithLoader();
        });
      } catch (error) {
        console.error("Error:", error);
        this.showError(error.message);
      }
    } catch (error) {
      console.error("Error:", error);
      this.showDiamondNotAvailable();
      // this.showError(error.message);
      // this.spinnerOverlayManager.hide();
    }
  }

  convertCurrency(diamond) {
    if (this.conversionRate !== 1) {
      diamond.price = (parseFloat(diamond.price) * this.conversionRate).toFixed(
        2
      );
      diamond.estimated_value = (
        parseFloat(diamond.estimated_value) * this.conversionRate
      ).toFixed(2);
      diamond.price_difference = (
        parseFloat(diamond.price_difference) * this.conversionRate
      ).toFixed(2);
    }
  }

  showDiamondNotAvailable() {
    // Hide the spinner
    this.spinnerOverlayManager.hide();
    
    // Clear the content container and show it
    this.content.innerHTML = '';
    this.content.style.display = 'block';
    
    // Create the alert message
    const alertHTML = `
      <div class="alert alert-warning" role="alert">
        <h1 class="alert-heading">Diamond No Longer Available</h1>
  
        <p>We're sorry, this diamond is no longer available. Our collection holds many other captivating diamonds that you may also love.</p>

        <p>Explore our current selection of diamonds and engagement rings to find the perfect match for you.</p>
        <div style="display: flex; padding-top: var(--lbd-large-margin)">
          <a href="/collections/engagement-rings" class="alert-link lbd-icon-diagonal-arrow">Engagement Rings ${window.diagonalarrowSvgContent || ''}</a>
          <div style="padding-left: var(--lbd-minor-margin); padding-right: var(--lbd-minor-margin); margin-top: -1px; color: var(--lbd-text-dark-color)">|</div>
          <a href="/pages/diamonds" class="alert-link lbd-icon-diagonal-arrow">Diamond Search ${window.diagonalarrowSvgContent || ''}</a>
        </div>
      </div>
    `;
    
    // Insert the alert into the content container
    this.content.innerHTML = alertHTML;
  }

  async fetchDiamondDetails(diamondId) {
    try {
      // Make API request to fetch diamond details by ID
      const response = await fetch(`${this.apiBaseUrl}/diamonds/${diamondId}`);

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch diamond details");
      }

      const result = await response.json();

      if (!result.success || !result.data) {
        this.spinnerOverlayManager.hide();
        this.showDiamondNotAvailable();
        throw new Error("Diamond not found");
        
      }

      return result.data;
    } catch (error) {
      console.error("API Error:", error);

      this.showDiamondNotAvailable();
      this.spinnerOverlayManager.hide();
      throw error;
      
    }

    // } finally {
    //   // Ensure the spinner is hidden even if there's an error
    //   this.spinnerOverlayManager.hide();
    // }
    
  }

  displayDiamondDetails(diamond) {
    function getShippingEstimateDate(daysToAdd = 14) {
      const days = Math.max(0, parseInt(daysToAdd) || 0);

      const today = new Date();
      const futureDate = new Date(today.getTime() + days * 24 * 60 * 60 * 1000);

      // Format the date as "DD Month YYYY"
      const options = { day: "numeric", month: "long", year: "numeric" };
      return futureDate.toLocaleDateString("en-AU", options);
    }

    let visitUrl;
    if (diamond.lab === "GIA") {
      visitUrl = "https://www.gia.edu/";
    } else if (diamond.lab === "IGI") {
      visitUrl = "https://www.igi.org/";
    }

    this.nameElement.textContent = `${diamond.carat} Carat ${diamond.shape} Diamond`;

    this.priceElement.innerHTML = `
        <div class="h5" style="padding-top: var(--lbd-minor-margin)">${Shopify.currency.active} ${parseFloat(diamond.price).toLocaleString()}</div>
        <div class="h5 lbd-minor-text-color" style="padding: var(--lbd-minor-margin) 0">Taxes included.</div>
        <div class="afterpay-message-position"></div>
        `;
    
    this.detailsElement.innerHTML = `
                              <div class="badge-container">
                              ${
                                (diamond.triple_x === true
                                  ? `
                                  <div style="display: flex; padding-bottom: var(--lbd-minor-margin)">${starSvgContent} <span>Triple Excellent</span></div>
                                  `
                                  : "") +
                                (diamond.hearts_and_arrows === true
                                  ? `<div style="display: flex; padding-bottom: var(--lbd-minor-margin)">${heartSvgContent} <span>Hearts and Arrows</span></div>`
                                  : "")
                              }
                              </div>
                              
                              <table class="lbd-table" style="margin-bottom: var(--lbd-minor-margin)">
                                <thead>
                                  <tr>
                                    <th>Carat</th>
                                    <th>Cut</th>
                                    <th>Colour</th>
                                    <th>Clarity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                  <td>${diamond.carat}</td>
                                  <td>${diamond.cut}</td>
                                  <td>${diamond.color}</td>
                                  <td>${diamond.clarity}</td>
                                  </tr>
                                </tbody>
                              </table>
      `;

    this.optionsAddToElement.innerHTML = `
                                          <div class="button-container">
                                            <button type="button" class="lbd-buy-button" id="add-to-ring-btn"> 
                                                Add to Ring
                                            </button>
                                            <button type="button" class="lbd-button" id="add-to-cart-btn">
                                                Add to Bag
                                            </button>
                                          </div>
        `;

    this.shippingInfoElement.innerHTML = `
            <ul>
              <li>All loose diamonds and engagement rings come with complimentary shipping within Australia.</li>
              <li>For this loose diamond, estimated arrival by ${getShippingEstimateDate(diamond.shipping_est_days)}.</li>
              <li>When purchasing with an engagement ring, complete your ring to view estimated delivery date.</li>
            </ul>
        `;


    this.productInfoElement.innerHTML = `
                          <div class="badge-container">
                              ${
                                (diamond.triple_x === true
                                  ? `
                                  <div style="display: flex; padding-bottom: var(--lbd-minor-margin)">${starSvgContent} <span>Triple Excellent</span></div>
                                  `
                                  : "") +
                                (diamond.hearts_and_arrows === true
                                  ? `<div style="display: flex; padding-bottom: var(--lbd-minor-margin)">${heartSvgContent} <span>Hearts and Arrows</span></div>`
                                  : "")
                              }
                              </div>



           <table class="lbd-table productinfo-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><i class="bi bi-info-circle" data-feather="circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Stone ID"></i>Stone No:</td>
                  <td>${diamond.id ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Certification number from the grading laboratory"></i>Certificate:</td>
                  <td>${diamond.lab ?? ''} Report No: ${diamond.lab_report ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Indicates the shipping method for this diamond"></i>Shipping:</td>
                  <td>${diamond.shipping_category ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The cut shape of the diamond"></i>Shape:</td>
                  <td>${diamond.shape ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Weight of the diamond (1 carat is equivalent to 0.2 grams)"></i>Carat:</td>
                  <td>${diamond.carat ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Diamond color grade, ranging from D (colourless) to Z (light yellow or brown)"></i>Colour:</td>
                  <td>${diamond.color ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade indicating any small imperfections or inclusions in the diamond"></i>Clarity:</td>
                  <td>${diamond.clarity ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade reflecting how well the diamond is cut, affecting its sparkle"></i>Cut:</td>
                  <td>${diamond.cut ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade of the diamond's surface smoothness"></i>Polish:</td>
                  <td>${diamond.polish ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade of the diamond's proportions and alignment of facets"></i>Symmetry:</td>
                  <td>${diamond.symmetry ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The unwanted glow the diamond produces under UV light"></i>Fluorescence:</td>
                  <td>${diamond.fluorescence ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The diamond's length in millimeters"></i>Length:</td>
                  <td>${diamond.length ?? ''} mm</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The diamond's width in millimeters"></i>Width:</td>
                  <td>${diamond.width ?? ''} mm</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The diamond's height in millimeters"></i>Height:</td>
                  <td>${diamond.height ?? ''} mm</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The height of a diamond from the culet to the table, expressed as a percentage of its average diameter"></i>Depth:</td>
                  <td>${diamond.depth ?? ''}%</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The width of the diamond's top facet, expressed as a percentage of the average diameter"></i>Table:</td>
                  <td>${diamond.table ?? ''}%</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Ratio of the diamond's length to its width"></i>Length To Width Ratio:</td>
                  <td>${diamond.length_to_width_ratio ?? ''}</td>
                </tr>
                <tr>
                  <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The small flat face at the bottom of the diamond"></i>Culet:</td>
                  <td>${
                    diamond.culet
                      ? diamond.culet.charAt(0).toUpperCase() + diamond.culet.slice(1).toLowerCase()
                      : ''
                  }</td>
                </tr>
              </tbody>
            </table>
   
    `;

    this.certificateInfoElement.innerHTML = `

            <ul>
              <li>This gemstone, whether loose or set in an engagement ring, comes with official certification from internationally recognised gemological laboratories such as GIA or IGI.</li>
              <li>Certified by ${diamond.lab ?? ''}.</li>
              <li>Report No: ${diamond.lab_report ?? ''}.</li>
            </ul>
            
          <div class="button-container">
            <button type="button" class="lbd-button" id="view-certificate-btn" onclick="window.open('${diamond.lab_verify_report_url}', '_blank')">
              <div class="lbd-icon-diagonal-arrow">View Certificate ${diagonalarrowSvgContent}</span>
            </button>
            <button type="button" class="lbd-button" id="view-lab-cert-url-btn" onclick="window.open('${visitUrl}', '_blank')">
              <div class="lbd-icon-diagonal-arrow">Visit ${diamond.lab.toUpperCase()} ${diagonalarrowSvgContent}</span>
            </button>
          </div>

    
    `;


    this.questionsInfoElement.innerHTML = `
          <ul>
          <li>Visit our FAQ for commonly asked questions.</li>
          <li>If you have any questions or would like assistsance, contact our dedicated support staff. We would be delighted to help you.</li>
          <li>We offer a 14-day return policy for all loose diamonds. </li>
          </ul>

    `;

    this.tableElement.innerHTML = ``;

    // Add modal HTML
    this.modalElement = document.createElement("div");
    this.modalElement.className = "certificate-modal";
    this.modalElement.innerHTML = `
            <div class="modal-content">
                <span class="close-modal">&times;</span>
                <h2>Diamond Certificate</h2>
                <iframe id="certificate-iframe" src="" width="100%" height="600px" scrolling="no"></iframe>
            </div>
        `;
    document.body.appendChild(this.modalElement);

    if (diamond.image) {
      this.imageElement.src = diamond.image;
      this.imageElement.alt = `${diamond.carat} Carat ${diamond.shape} Diamond`;
    }

    if (diamond.image2) {
      this.mediaContainer2.style.display = "block";
      this.imageElement2.src = diamond.image2;
      this.imageElement2.alt = `${diamond.carat} Carat ${diamond.shape} Diamond`;
    } else {
      this.mediaContainer2.style.display = "none";
    }

    new Diamond4CsInfographic(diamond);

    this.setupEventListeners();
    // Initialize tooltips
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }

  setupMediaWithLoader() {
    if (!this.diamond || !this.mediaContainer) return;

    // Ensure the media container has an ID
    if (!this.mediaContainer.id) {
      this.mediaContainer.id = `diamond-media-container-${this.diamond.id}`;
    }

    // Add a dynamic media container inside the main media container if not exists
    let dynamicMediaContainer = this.mediaContainer.querySelector('.dynamic-media-container');
    if (!dynamicMediaContainer) {
      dynamicMediaContainer = document.createElement('div');
      dynamicMediaContainer.className = 'dynamic-media-container d-none position-absolute top-0 start-0 w-100 h-100';
      dynamicMediaContainer.style.zIndex = '20';
      this.mediaContainer.appendChild(dynamicMediaContainer);
    }

    // Handle initial image loading
    if (this.imageElement) {
      this.mediaLoader.handleImageLoading(this.imageElement, this.mediaContainer.id, {
        size: 'medium',
        backgroundColor: 'rgba(255, 255, 255, 0.9)'
      });
    }

    // Setup media interaction (hover/touch for video)
    this.mediaLoader.setupMediaInteraction(
      this.diamond,
      this.mediaContainer,
      this.imageElement,
      dynamicMediaContainer
    );

    // Handle secondary image if exists
    if (this.imageElement2 && this.mediaContainer2) {
      if (!this.mediaContainer2.id) {
        this.mediaContainer2.id = `diamond-media-container-2-${this.diamond.id}`;
      }
      this.mediaLoader.handleImageLoading(this.imageElement2, this.mediaContainer2.id, {
        size: 'medium',
        backgroundColor: 'rgba(255, 255, 255, 0.9)'
      });
    }
  }



  showError(message) {
    const errorElement = document.createElement("div");
    errorElement.className = "alert alert-danger";
    errorElement.textContent = message;
    this.mediaContainer.parentNode.insertBefore(
      errorElement,
      this.mediaContainer
    );
  }

  setupEventListeners() {
    
    const addToCartButton = document.getElementById("add-to-cart-btn");
    const addToRingButton = document.getElementById("add-to-ring-btn");


    addToCartButton.addEventListener("click", this.addToCart.bind(this));
    addToRingButton.addEventListener("click", this.addToRingBuilder.bind(this));

    
  }

  async addToCart() {
    if (!this.diamond) {
      console.error("Diamond data is not available");
      alert("Failed to add diamond to bag. Please try again.");
      return;
    }

    try {
      this.spinnerOverlayManager.show();
      await this.cartManager.addToCart(this.diamond);
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("Failed to add diamond to bag. Please try again.");
    } finally {
      // Ensure the spinner is hidden even if there's an error
      this.spinnerOverlayManager.hide();
    }
  }


  addToRingBuilder() {
    if (!this.diamond) {
      console.error("Diamond data is not available");
      alert("Failed to add diamond to ring builder. Please try again.");
      return;
    }

    const rawShape = this.diamond.shape;
    
    // Cushion Base Map
    let cushionGroupName;
    if (
      (rawShape === "Cushion Modified" || rawShape === "Cushion Brilliant") &&
      this.diamond.length_to_width_ratio < 1.1
    ) {
      cushionGroupName = "Cushion Square";
    } else if (
      (rawShape === "Cushion Modified" || rawShape === "Cushion Brilliant") &&
      this.diamond.length_to_width_ratio >= 1.1
    ) {
      cushionGroupName = "Cushion";
    } else {
      // fallback for other shapes
      cushionGroupName = rawShape;
    }

    // normalize to your base‑shape for storage & path
    const baseMap = {
      "Cushion Modified": cushionGroupName,
      "Cushion Brilliant": cushionGroupName,
      "Square Emerald": "Emerald",
      "Square Radiant": "Radiant"
    };

    const baseShape = baseMap[rawShape] || rawShape; 
  
    // store only the normalized shape
    localStorage.setItem("selectedDiamond", JSON.stringify(this.diamond));
    const storedShape = localStorage.getItem("selectedShape");
    const selectedRing = localStorage.getItem("selectedRing");


    if (selectedRing && storedShape === baseShape) {
      // same base shape => go straight to completion
      window.location.href = "/pages/complete-your-ring";
    } else {
      // new or changed shape: clear any old ring data
      localStorage.removeItem("selectedRing");
  
      // store the normalized shape
      localStorage.setItem("selectedShape", baseShape);
  
      // build the path using only the baseShape
      const pathSegment = baseShape.toLowerCase().replace(' ', '-');             
      const queryShape = encodeURIComponent(baseShape);          // preserves spaces
      window.location.href =
        `/collections/${pathSegment}-cut-engagement-rings`
    }
    
  }


  
}

document.addEventListener("DOMContentLoaded", () => {
  new DiamondDetails();
});

class Diamond4CsInfographic {
  constructor(diamond) {
    this.diamond = diamond;
    this.container = document.getElementById("diamond-4Cs-infographic");
    this.descriptors = {
      carat: [
        {
          range: [0, 1],
          text: "When worn on a ring, this diamond may appear very small in size.",
        },
        {
          range: [1, 2],
          text: "When worn on a ring this diamond may appear small in size.",
        },
        {
          range: [2, 3],
          text: "When worn on a ring, this diamond may appear medium in size.",
        },
        {
          range: [3, 5],
          text: "When worn on a ring, this diamond may appear large in size.",
        },
        {
          range: [5, 11],
          text: "When worn on a ring, this diamond may appear very large in size.",
        },
      ],
      cut: {
        Fair: "Basic cut with minimal light reflection.",
        Good: "Decent cut with moderate brilliance.",
        "Very Good": "Well-cut with very good light reflection.",
        Excellent: "Precise cut with excellent brilliance.",
        Ideal: "Perfectly proportioned for maximum brilliance.",
      },
      clarity: {
        I1: "Inclusions visible to the naked eye.",
        SI2: "Slight inclusions visible under 10x magnification.",
        SI1: "Slight inclusions, difficult to see under 10x magnification.",
        VS2: "Very slight inclusions, barely visible under 10x magnification.",
        VS1: "Very slight inclusions, difficult for a skilled grader to see.",
        VVS2: "Very, very slight inclusions, difficult to see even for skilled graders.",
        VVS1: "Very, very slight inclusions, only visible with high-powered microscope.",
        IF: "Internally Flawless, no inclusions visible under 10x magnification.",
        FL: "Flawless, no inclusions or blemishes visible under 10x magnification.",
      },
      colour: {
        J: "Near colourless, slight yellow tint may be visible.",
        I: "Near colourless, very slight yellow tint.",
        H: "Near colourless, difficult to detect colour.",
        G: "Near colourless, colour difficult to detect unless compared side by side.",
        F: "Colourless, no detectable colour.",
        E: "Colourless, rare and valuable.",
        D: "Colourless, highest colour grade, extremely rare.",
      },
    };
    this.init();
  }

  init() {
    this.createHTML();
    this.initializeSliders();
  }

  createHTML() {
    this.container.innerHTML = `
            <div class="row">
                ${this.createInfoCard("Carat", this.diamond.carat, "0", "10")}
                ${this.createInfoCard("Cut", this.diamond.cut, "Fair", "Ideal")}
                ${this.createInfoCard("Clarity", this.diamond.clarity, "I1", "FL")}
                ${this.createInfoCard("Colour", this.diamond.color, "J", "D")}
            </div>
        `;
  }

  createInfoCard(title, value, min, max) {

    const isEmptyCut = title === "Cut" && (value === "none" || value === "-" || !value);
    
    return `
      <div class="col-12 col-md-6" style="padding-top: var(--lbd-minor-margin); padding-left: 0; padding-right: var(--lbd-minor-margin);">
          <div class="card">
              <div class="card-body" style="padding: 0; display: flex; flex-direction: column; height: 100%;">
                  <div>
                      <div class="d-flex justify-content-between align-items-center">
                          <div class="h2" style="padding-top: var(--lbd-minor-margin)">${isEmptyCut ? '' : title}</div>
                          <div class="card-text h5">${isEmptyCut ? '' : value}</div>
                      </div>
                      <div class="descriptor-text"></div>
                      <div class="ddp-categorical-slider-class">
                          <div id="${title.toLowerCase()}-slider" class="ddp-categorical-slider"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
        `;
  }

  initializeSliders() {
    this.initializeCaratSlider();
    

    if (this.diamond.cut && this.diamond.cut !== "none" && this.diamond.cut !== "-") {
      this.initializeStaticSlider("cut", [
        "Fair",
        "Good",
        "Very Good",
        "Excellent",
        "Ideal",
      ]);
    } else {
      // Leave the cut slider container empty but maintain the space
      const cutSlider = document.getElementById("cut-slider");
      if (cutSlider) {
        // Add a min-height to maintain consistent spacing
        cutSlider.style.minHeight = "60px"; // Adjust this value to match other sliders
      }
    }
        

    
    this.initializeStaticSlider("clarity", [
      "I1",
      "SI2",
      "SI1",
      "VS2",
      "VS1",
      "VVS2",
      "VVS1",
      "IF",
      "FL",
    ]);
    this.initializeStaticSlider("colour", ["J", "I", "H", "G", "F", "E", "D"]);
  }

  initializeCaratSlider() {
    const slider = document.getElementById("carat-slider");
    const descriptorElement = slider
      .closest(".card-body")
      .querySelector(".descriptor-text");

    noUiSlider.create(slider, {
      start: [this.diamond.carat],
      connect: "lower",
      range: {
        min: 0,
        max: 10,
      },
      step: 0.01,
      tooltips: true,
      pips: {
        mode: "values",
        values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        density: 100,
        format: {
          to: function (value) {
            return Math.round(value) + " ct";
          },
        },
      },
    });

    slider.setAttribute("disabled", true);

    const updateCaratDescription = (value) => {
      const descriptor = this.descriptors.carat.find(
        (d) => value >= d.range[0] && value < d.range[1]
      );
      descriptorElement.textContent = descriptor ? descriptor.text : "";
    };

    slider.noUiSlider.on("update", (values, handle) => {
      const value = parseFloat(values[handle]);
      slider.closest(".card-body").querySelector(".card-text").textContent =
        value.toFixed(2);
      updateCaratDescription(value);
    });

    // Initial update
    updateCaratDescription(this.diamond.carat);
  }

  initializeStaticSlider(name, values) {

    const slider = document.getElementById(`${name}-slider`);
    if (!slider) return; // Safety check
    
      
    const valueKey = name === "colour" ? this.diamond.color : this.diamond[name];
    const index  = values.indexOf(valueKey);

    // If the value is not found in the array, don't create the slider
    if (index === -1) {
      // Add min-height to maintain consistent spacing
      slider.style.minHeight = "60px";
      return;
    }
    

    const descriptorElement = slider
      .closest(".card-body")
      .querySelector(".descriptor-text");

    noUiSlider.create(slider, {
      start: [index],
      connect: "lower",
      range: {
        min: 0,
        max: values.length - 1,
      },
      step: 1,
      tooltips: false,
      pips: {
        mode: "steps",
        density: 100,
        format: {
          to: (value) => values[Math.round(value)],
        },
      },
    });

    slider.setAttribute("disabled", true);

    // Set initial descriptor
    descriptorElement.textContent = this.descriptors[name][ valueKey ];
  }
}
